import React from 'react';
import ActionsTab from '../actions-tab/actions-tab';
import DetailsTab from '../details-tab/details-tab';
import GeneralInfoTab from '../general-info-tab/general-info-tab';
import LogsTab from '../logs-tab/logs-tab';
import RelatedResourcesTab from '../related-resources-tab/related-resources-tab';
import {Route, Routes} from 'react-router';

const InvoiceDetailsRouter = () => {
  return (
    <Routes>
      <Route path="/general" element={<GeneralInfoTab />} />
      <Route path="/details" element={<DetailsTab />} />
      <Route path="/related-resources" element={<RelatedResourcesTab />} />
      <Route path="/logs" element={<LogsTab />} />
      <Route path={`/`} element={<div>Nothing…</div>} />
    </Routes>
  );
};

export default InvoiceDetailsRouter;
